"use client";

import { c as _c } from "react/compiler-runtime";
import { Link } from "@/components/Link/Link.component";
import { Translation } from "@/components/Translation/Translation.component";
import { usePaywall } from "@/contexts/paywall/paywall.context";
import { useSite } from "@/contexts/site/site.context";
import { useCurrentUrl } from "@/hooks/use-current-url.hook";
const trialHeader = {
  da: "Få et uforpligtende prøveabonnement her.",
  de: "Erhalten Sie hier ein unverbindliches Probeabonnement.",
  en: "Get a non-binding trial subscription here.",
  no: "Få et uforpliktende prøveabonnement her.",
  sv: "Få ett icke-bindande provabonnemang här."
};
export function PaywallAddTrial() {
  const $ = _c(11);
  const {
    relative: relativeUrl
  } = useCurrentUrl();
  const {
    name: siteName
  } = useSite();
  const {
    trial
  } = usePaywall();
  const isTrialExpired = trial?.isUserTrialExpired ?? false;
  if (trial === null || isTrialExpired) {
    return null;
  }
  const {
    numberOfFreeTrialDays
  } = trial;
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <p className="flex-auto"><Translation model={trialHeader} /></p>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const t1 = `/profile/add/trial?redirectUrl=${relativeUrl}&type=add-trial`;
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      contentId: "add-trial",
      contentSource: "paywall",
      contentType: "cta"
    };
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const t3 = `Prøv ${siteName} i ${numberOfFreeTrialDays} dage - og få adgang til alt indhold.`;
  const t4 = `Testen Sie ${siteName} ${numberOfFreeTrialDays} Tage lang - und erhalten Sie Zugang zu allen Inhalten.`;
  const t5 = `Try ${siteName} for ${numberOfFreeTrialDays} days - and get access to all content.`;
  const t6 = `Prøv ${siteName} i ${numberOfFreeTrialDays} dager - og få tilgang til alt innhold.`;
  const t7 = `Prova ${siteName} i ${numberOfFreeTrialDays} dagar - och få tillgång till allt innehåll.`;
  let t8;
  if ($[2] !== t3 || $[3] !== t4 || $[4] !== t5 || $[5] !== t6 || $[6] !== t7) {
    t8 = <Translation model={{
      da: t3,
      de: t4,
      en: t5,
      no: t6,
      sv: t7
    }} />;
    $[2] = t3;
    $[3] = t4;
    $[4] = t5;
    $[5] = t6;
    $[6] = t7;
    $[7] = t8;
  } else {
    t8 = $[7];
  }
  let t9;
  if ($[8] !== t1 || $[9] !== t8) {
    t9 = <div className="inline-flex flex-col gap-0.5 text-center text-sm md:text-base">{t0}<Link className="text-primary hover:text-primary-hover hover:underline" href={t1} position="pw-adtr-btn" testId="paywall-add-trial" trackingModel={t2}>{t8}</Link></div>;
    $[8] = t1;
    $[9] = t8;
    $[10] = t9;
  } else {
    t9 = $[10];
  }
  return t9;
}